module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"title":"Horaires","departure":"Départ de","arrival":"Arrivée à","errors":{"one-hour-delta":"Un intervalle d\u0027une heure minimum est requis"}},"en":{"title":"Schedules","departure":"Departure from","arrival":"Arrival in","errors":{"one-hour-delta":"An interval of at least one hour is required"}}}')
  delete Component.options._Ctor
}
